export class User {
  organizationId: number;

  userId: number;

  regionId: number;

  name: string;

  roles: string[];

  token: string;

  constructor(json?: any) {
    if (!json) {
      return;
    }
    this.organizationId = json.organizationId;
    this.userId = json.userId;
    this.regionId = json.regionId;
    this.name = json.name;
    this.roles = json.roles;
  }

  isInRole(roles: string[]) {
    for (let i = 0; i < roles.length; i++) {
      if (this.roles.indexOf(roles[i]) > -1) {
        return true;
      }
    }
    return false;
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/models/User.ts